// extracted by mini-css-extract-plugin
export default {"wrapper":"appteaser_wrapper__o0onc","info":"appteaser_info__GDWDk","title":"appteaser_title__xVVRq","links":"appteaser_links__CYJ7e"};